import React from 'react';
import { Svg } from 'src/components/Svg/Svg';
import { usePhoneNumber } from 'src/util/getPhoneNumber';

import classes from './MethodInfo.scss';

type Props = {
    noEmbroidery: boolean;
    noPrint: boolean;
};

export const MethodInfo: React.FC<Props> = ({ noEmbroidery, noPrint }) => {
    const phoneNumber = usePhoneNumber('spaced');
    return (
        <div className={classes.warning}>
            {noEmbroidery && (
                <div>
                    <b>
                        <Svg name="alert" /> Embroidery (stitching) isn't available for one of the below reasons:
                    </b>
                    <ul>
                        <li>The garment weight (GSM) is too low to allow embroidery on this position.</li>
                        <li>Embroidery isn't an applicable on this product/bundle</li>
                        <li>You have chosen a Print only artwork position</li>
                    </ul>
                    Please call us on <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> if you wish to embroider this
                    item we might be able to help!
                </div>
            )}
            {noPrint && (
                <div>
                    <b>
                        <Svg name="alert" /> Print isn't available on this position for one of the below reasons;:
                    </b>
                    <ul>
                        <li>Due to the material we don't recommend print</li>
                        <li>The surface area of the position doesn't allow us to print it</li>
                        <li>Print isn't an option on this product/bundle</li>
                        <li>You have chosen an Embroidery only artwork position</li>
                    </ul>
                    Please call us on <a href={`tel:${phoneNumber}`}>{phoneNumber}</a> if you wish print this item we
                    might be able to help!
                </div>
            )}
        </div>
    );
};
